export const operationDatePlanCalc = (startDate: string, endDate: string) => {
  const start = new Date(startDate);
  start.setDate(start.getDate() - 1);
  const end = new Date(endDate);
  const startYear = start.getFullYear();
  const startMonth = start.getMonth();
  const endYear = end.getFullYear();
  const endMonth = end.getMonth();
  const yearDiff = endYear - startYear;
  const monthDiff = endMonth - startMonth;

  let totalDiff = yearDiff * 12 + monthDiff;

  // 開始・終了を1月以内に調整する
  start.setDate(start.getDate() + 1);
  const originalMonth = start.getMonth();
  start.setMonth(start.getMonth() + totalDiff);
  if (originalMonth !== start.getMonth()) {
    start.setDate(start.getDate() - 1);
  }

  // 15日以上あれば、1月分プラス(-15日であればマイナス)する必要がある
  const dateDiff = (end.getTime() - start.getTime()) / 86400000;
  const adjust = Math.abs(dateDiff) >= 15 ? (dateDiff > 0 ? 1 : -1) : 0;
  totalDiff += adjust;

  const year = Math.floor(totalDiff / 12);
  const month = totalDiff % 12;

  const result = year === 0 ? `${month}ヶ月` : `${year}年${month}ヶ月`;
  return result;
};
